import { render, staticRenderFns } from "./ShelfBoxManagement.vue?vue&type=template&id=7f9f2e7a"
import script from "./ShelfBoxManagement.vue?vue&type=script&lang=js"
export * from "./ShelfBoxManagement.vue?vue&type=script&lang=js"
import style0 from "./ShelfBoxManagement.vue?vue&type=style&index=0&id=7f9f2e7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports